export default __webpack_public_path__ + "static/media/NIE_touchpoint_07.e87db8bf.mp4";